import { Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import Link from 'src/components/Link';
import { AppPageRoutes } from 'src/services/api/models';
import CONFIG from 'src/utils/config';
import { AppBrands } from 'src/utils/constants';

export const PageFooter = () => {
    const isQwic = CONFIG.APP_BRAND === AppBrands.QWIC;
    const intl = useIntl();

    if (!isQwic) {
        return null;
    }

    return (
        <>
            <Typography variant="caption" component="p">
                <FormattedMessage id="spareParts.itemNotOnTheList.info" />
            </Typography>
            <Typography variant="caption" component="p">
                <FormattedMessage
                    id="spareParts.itemNotOnTheList.contact"
                    values={{
                        contact: (
                            <Link href={AppPageRoutes.CONTACT}>
                                {intl.formatMessage({ id: 'contact.customerService' })}
                            </Link>
                        ),
                    }}
                />
            </Typography>
            <Typography variant="caption" component="p">
                <FormattedMessage
                    id="spareParts.itemNotOnTheList.otherSearch"
                    values={{
                        link: (
                            <Link href={`${AppPageRoutes.NEW_RETURN_REQUEST}?categories=sparePartSearch`}>
                                {intl.formatMessage({
                                    id: 'spareParts.itemNotOnTheList.otherSearch.link',
                                })}
                            </Link>
                        ),
                    }}
                />
            </Typography>
        </>
    );
};
